import React, { Component } from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  FormItem,
  Selection,
  Summary,
  TotalItem
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContribuinteDs, criarCdaDs } from "../../DataSources";
import Form, { SimpleItem, Label, EmptyItem, TabPanelOptionsItem } from "devextreme-react/form";
import { Button, LoadIndicator, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import showReport from "../../showReport";
import {downloadArquivoBase64} from "../../showReport";
import UserInfo from "../../UserInfo";
import api from "../../api-axios";
import notify from "devextreme/ui/notify";
import ShowError from "../../AppServices";
import { formatNumber } from 'devextreme/localization';


const localStorageKey = "cadastroCdaGridState";

const estadoPadrao = {
  popupCarregando: false,
  popupSolicitarCobranca: false,
  selecionando: false,
  cdasSelecionadas: [],
  dadosSucessoSolicitacao: [],
  tipoCobranca: -1,
  filtroCorrente: [],
  filtro: {
    ano: undefined,
    numeroInicial: undefined,
    numeroFinal: undefined,
    contribuinteId: undefined,
    situacao: -2,
    tipoCobranca: -1,
    emSolicitacao: -1
  },
  popupVisivel: false,
  tipoSolicitacaoCobranca: 1,
  acaoSolicitacaoCobranca: 0, // 0 - nenhuma, 1 - solicitar, 2 - cancelar solicitação
  _uiNome: "",
};

export default class CdaBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this._formInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = { ...estadoPadrao };

    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.iniciarSelecao = this.iniciarSelecao.bind(this);
    this.cancelarSelecao = this.cancelarSelecao.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.solicitarCobranca = this.solicitarCobranca.bind(this);
    this.cancelarCobranca = this.cancelarCobranca.bind(this);
    this.customizarTextoSumary = this.customizarTextoSumary.bind(this);
    this.baixarZip = this.baixarZip.bind(this);
    this.confirmarSolicitarCobranca = this.confirmarSolicitarCobranca.bind(this);



    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.cdaDs = criarCdaDs();

    //
    /* Funções do contribuinte
     */
    this.contribuinteDs = criarContribuinteDs();
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.filtro.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNome,
      this.pesquisarContribuinte
    );
    //
    /* Fim das funções do contribuinte
     */
    this.cancelarCda = this.cancelarCda.bind(this);

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: " " },
        { id: -2, descricao: "ATIVA" },
        { id: 0, descricao: "GERADO" },
        { id: 5, descricao: "EM SOLICITACAO" },
        { id: 6, descricao: "EM COBRANCA" },
        { id: 2, descricao: "CANCELADO" }
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.tipoCobrancaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: " " },
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "PROTESTO" },
        { id: 2, descricao: "EXECUÇÃO FISCAL" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.tipoSolicitacaoCobrancaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "" },
        { id: 1, descricao: "PROTESTO" },
        { id: 2, descricao: "EXECUÇÃO FISCAL" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };

    this.emSolicitacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: " " },
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };
  }

  componentDidMount() {
    this.filtrar();
  }

  async cancelarCda(e) {
    try {
      await api.post(`/cda/cancelar/${UserInfo.getPrefeitura()}/${e.row.data.id}`);
      notify("CDA cancelada com sucessso.", "success");
      this._gridInstance.instance.refresh();
    }
    catch (error) {
      ShowError(error);
    }
  }

  iniciarSelecao(e) {

    this.setState({ selecionando: true });
  }

  cancelarSelecao(e) {
    this.setState({ selecionando: false, cdasSelecionadas: [] });
  }

  onSelectionChanged(e) {
    console.log("seleção args", e);
    this.setState({ cdasSelecionadas: e.selectedRowsData });
  }

  solicitarCobranca(e) {
    this.setState({ popupSolicitarCobranca: true, acaoSolicitacaoCobranca: 1 });
    console.log("estado para cobrança: ", this.state)
  }



  confirmarSolicitarCobranca(e) {

    if (this.state.cdasSelecionadas.length == 0) {
      notify("Nenhuma CDA selecionada para a ação", "error");
      return;
    }

    let url, request;

    if (this.state.acaoSolicitacaoCobranca == 1) {
      url = `/diat/gerar_solicitacoes/${UserInfo.getPrefeitura()}`;
      request = this.state.cdasSelecionadas.map(function (x) {
        return { cdaId: x.id, tipoSolicitacao: 2 }
      });
    }
    else {
      url = `/diat/cancelar_solicitacoes/${UserInfo.getPrefeitura()}`;
      request = this.state.cdasSelecionadas.map(function (x) {
        return { cdaId: x.id }
      });
    }

    this.setState({
      popupSolicitarCobranca: false,
      popupCarregando: true,
    }, () => {
      api
        .post(url, request)
        .then(resp => {
          if (resp.data.sucesso) {
            this.setState({ popupCarregando: false, popupSucessoSolicitacao: true, dadosSucessoSolicitacao: resp.data.itens });
          }
        })
        .catch(error => {
          console.log(error);
          notify("Erro desconhecido", "error");
          this.setState({ popupCarregando: false, popupSolicitarCobranca: true });
        });
    });
  }

  cancelarCobranca(e) {
    this.setState({ acaoSolicitacaoCobranca: 2, popupSolicitarCobranca: true });
    console.log("estado para cobrança: ", this.state)
  }

  baixarZip(e) {

    this.setState({ popupCarregando: true }, () => {
      const request = {
        prefeituraId: UserInfo.getPrefeitura(),
        cdasIds: this.state.cdasSelecionadas.map(x => x.id)
      };

      console.log("CDA Zip Request", request);

      api.post("/report/cda_lote", request)
        .then(resp => {
          downloadArquivoBase64("cda.zip", resp.data.report);
        })
        .catch(error => {
          console.log("Error CDA ZIP", error);
          notify("Erro desconhecido", "error");
        })
        .finally(() => {
          this.setState({ popupCarregando: false });
        })




    });

  }

  filtrar(e) {

    let filtro = this.state.filtro;

    console.log("filtro", filtro);

    let filtroCorrente = [];

    if (filtro.ano != undefined && filtro.ano != "") {
      filtroCorrente.push(["ano", "=", filtro.ano.trim()]);
    }

    if (filtro.numeroInicial != undefined && filtro.numeroInicial !== "") {
      filtroCorrente.push(["numero", ">=", filtro.numeroInicial.trim()]);
    }

    if (filtro.numeroFinal != undefined && filtro.numeroFinal !== "") {
      filtroCorrente.push(["numero", "<=", filtro.numeroFinal.trim()]);
    }

    if (filtro.situacao != -1) {
      filtroCorrente.push(filtro.situacao == -2 ? ["status", "<>", 2] : ["status", "=", filtro.situacao]);
    }

    if (filtro.contribuinteId != undefined && filtro.contribuinteId != "") {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.contribuinteId.trim(),
      ]);
    }
    console.log("filtrado!");

    if (filtroCorrente.length > 0) {
      this._gridInstance.instance.filter(filtroCorrente);
    } else {
      this._gridInstance.instance.clearFilter();
    }

    this._gridInstance.instance.refresh();
  }

  limparFiltro(e) {
    this.setState({ filtro: { situacao: -2, tipoCobranca: -1, emSolicitacao: -1 } }, () => {
      console.log("state limpar filtro", this.state);
      this._formInstance.instance.repaint();
      this.filtrar();
    });

  }

  setContribuinteId(data) {
    if (data.value == undefined || data.value == "") {
      this.setState({ _uiNome: "", filtro: { contribuinteId: null } });
      return;
    }

    let estado = {};
    Object.assign(estado, this.state);
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            Object.assign(estado, { _uiNome: "" });
          } else {
            Object.assign(estado, { _uiNome: result[0].nome });
          }
        } else {
          Object.assign(estado, { _uiNome: "" });
        }
        this.setState({
          ...estado,
          filtro: { ...this.state.filtro, contribuinteId: data.value },
          popupVisivel: false,
        });
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNome: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    let data = {};
    Object.assign(data, { value: e.row.data.sequencial.toString() });
    this.setContribuinteId(data);
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("cda/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <div style={{ display: this.state.selecionando ? "none" : "inline-block", width: "100%" }}>
              <Form
                id="frmPesquisa"
                ref={x => this._formInstance = x}
                formData={this.state.filtro}
                colCount={5}
                labelLocation={"top"}
              >
                <SimpleItem dataField="ano" colSpan={1}>
                  <Label text="Exercício" />
                </SimpleItem>
                <SimpleItem dataField="numeroInicial" colSpan={1}>
                  <Label text="N.º Inicial" />
                </SimpleItem>
                <SimpleItem dataField="numeroFinal" colSpan={1}>
                  <Label text="N.º Final" />
                </SimpleItem>

                <SimpleItem dataField="situacao" colSpan={1} editorType={"dxSelectBox"} editorOptions={this.situacaoOptions} >
                  <Label text="Situação" />
                </SimpleItem>
                <SimpleItem dataField="tipoCobranca" colSpan={1} editorType={"dxSelectBox"} editorOptions={this.tipoCobrancaOptions} >
                  <Label text="Tipo Cobrança" />
                </SimpleItem>
                <SimpleItem colSpan={5} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>
              </Form>
            </div>

            <div
              style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: this.state.selecionando ? "none" : "inline-block" }}>
                <Button
                  icon="filter"
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "none" : "inline-block" }}>
                <Button icon="clear" text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "none" : "inline-block" }}>
                <Button icon="selectall" text="Modo Seleção" onClick={this.iniciarSelecao} />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "inline-block" : "none" }}>
                <Button icon="back" text="Voltar" onClick={this.cancelarSelecao} />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "inline-block" : "none" }}>
                <Button icon="export" text="Solicitar cobrança" onClick={this.solicitarCobranca} />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "inline-block" : "none" }}>
                <Button icon="close" text="Cancelar solicitação" onClick={this.cancelarCobranca} />
              </div>
              <div style={{ marginLeft: "10px", display: this.state.selecionando ? "inline-block" : "none" }}>
                <Button icon="save" text="Baixar .zip" onClick={this.baixarZip} />
              </div>
            </div>
          </form>
          <PaginaToolbar
            suprimir={this.state.selecionando}
            titulo="Lista de CDA's"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.cdaDs}
              showBorders={true}
              rowAlternationEnabled={!this.state.selecionando}
              remoteOperations={true}
              columnAutoWidth={true}
              filterSyncEnabled={true}
              wordWrapEnabled={true}
              onSelectionChanged={this.onSelectionChanged}
            >

              <Column
                type="buttons"
                visible={!this.state.selecionando}
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "CDA",
                    icon: "exportselected",
                    onClick: function (e) {
                      showReport("/report/cda", {
                        cdasIds: [e.row.data.id],
                        prefeituraId: UserInfo.getPrefeitura(),
                      });
                    },
                  },
                  {
                    hint: "Termos",
                    icon: "exportpdf",
                    onClick: function (e) {
                      showReport("/report/cda_termos", {
                        cdasIds: [e.row.data.id],
                        prefeituraId: UserInfo.getPrefeitura(),
                      });
                    },
                  },
                  {
                    hint: "Tudo",
                    icon: "selectall",
                    onClick: function (e) {
                      showReport("/report/cda_tudo", {
                        cdasIds: [e.row.data.id],
                        prefeituraId: UserInfo.getPrefeitura(),
                      });
                    },
                  },
                  {
                    hint: "Cancelar",
                    icon: "remove",
                    onClick: e => this.cancelarCda(e)
                  },
                  {
                    hint: "Notificação",
                    icon: "warning",
                    onClick: (e) => {
                      showReport(
                        `/cda/notificar/${UserInfo.getPrefeitura()}/${e.row.data.id
                        }`
                      );
                    },
                  },
                  {
                    hint: "Atualizar",
                    visible: false,
                    icon: "pulldown",
                    onClick: function () {
                      alert("Atualizar");
                    },
                  },
                ]}
              />
              <Selection
                mode={this.state.selecionando ? "multiple" : "none"}
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column
                dataField={"sequencial"}
                caption={"#"}
                width={105}
                alignment={"center"}
                sortOrder="desc"
                sortIndex={1}
              />
              <Column
                dataField={"data"}
                dataType={"date"}
                caption={"Data"}
                alignment={"center"}
                width={110}
              />
              <Column
                dataField={"certidaoNumeroStr"}
                caption={"Número"}
                width={110}
                alignment={"center"}
              />
              <Column dataField={"naturezaDoCredito"} caption={"Natureza"} width={120} />
              <Column dataField={"statusStr"} caption={"Situação"} width={150} />

              <Column dataField={"contribuinte.cpfCnpjFormatado"} caption={"CPF/CNPJ"} width={160} />
              <Column dataField={"contribuinte.nomeECodigo"} caption={"Contribuinte"} />

              <Column dataField={"solicitacaoCorrente.statusStr"} caption={"Sit. Solicitação"} width={150} />
              <Column dataField={"solicitacaoCorrente.tipoStr"} caption={"Tipo Solicitação"} width={150} />
              <Column
                dataField={"principal"}
                caption={"Principal"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Column
                dataField={"correcao"}
                caption={"Correção"}
                format={{ type: "fixedPoint", precision: 2 }}
                visible={false}
              />
              <Column
                dataField={"multa"}
                caption={"Multa"}
                format={{ type: "fixedPoint", precision: 2 }}
                visible={false}
              />
              <Column
                dataField={"juros"}
                caption={"Juros"}
                format={{ type: "fixedPoint", precision: 2 }}
                visible={false}
              />
              <Column
                dataField={"total"}
                caption={"Total"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
              {/* <Summary>
                <TotalItem
                  column="principal"
                  summaryType="sum"
                  valueFormat="currency"
                />
                <TotalItem
                  column="correcao"
                  summaryType="sum"
                  valueFormat="currency"
                />
                <TotalItem
                  column="multa"
                  summaryType="sum"
                  valueFormat="currency"
                />
                <TotalItem
                  column="juros"
                  summaryType="sum"
                  valueFormat="currency"
                />
                <TotalItem
                  column="total"
                  summaryType="sum"
                  valueFormat="currency"
                />
              </Summary> */}
            </DataGrid>
          </PaginaToolbar>
          <br />
          <Form
            formData={this.state}
            colCount={9}
            labelLocation={"top"}
            visible={false}
          >
            <EmptyItem colSpan={4} />
            <SimpleItem
              colSpan={1}
              dataField={"principal"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Principal (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalMulta"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Multa (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalJuros"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Juros (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"totalCorrecao"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Correção (R$)" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"valorTotal"}
              editorType={"dxNumberBox"}
              cssClass="box-n2 readOnlyBox"
              editorOptions={{
                readOnly: true,
                format: { type: "fixedPoint", precision: 2 },
              }}
            >
              <Label text="Total (R$)" />
            </SimpleItem>
          </Form>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>

          <Popup
            visible={this.state.popupSolicitarCobranca}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Finalizar Solicitação"
          >
            <div style={{ display: this.state.acaoSolicitacaoCobranca == 1 ? "block" : "none" }} >
              <form onSubmit={this.confirmarSolicitacaoCobranca}>
                <div>
                  <Form
                    id="frmConfirmarSolicitacaoCobranca"
                    formData={this.state}
                    colCount={1}
                    labelLocation={"left"}
                  >
                    <SimpleItem dataField="tipoSolicitacaoCobranca" colSpan={2} editorType={"dxSelectBox"} editorOptions={this.tipoSolicitacaoCobrancaOptions} >
                      <Label text="Tipo Cobrança" />
                    </SimpleItem>
                    <EmptyItem colSpan={2} />
                  </Form>
                </div>
              </form>

            </div>
            <DataGrid
              dataSource={this.state.cdasSelecionadas}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
              filterSyncEnabled={true}
              wordWrapEnabled={true}
              onSelectionChanged={this.onSelectionChanged}
              height={"95%"}
            >
              <Paging pageSize={this.state.cdasSelecionadas.length} />
              <Pager visible={false} />
              <Column
                dataField={"certidaoNumeroStr"}
                caption={"Número"}
                width={110}
                alignment={"center"}
              />

              <Column dataField={"naturezaDoCredito"} caption={"Natureza"} width={120} />
              <Column dataField={"statusStr"} caption={"Situação"} width={170} />
              <Column dataField={"tipoCobrancaStr"} caption={"Tipo Cobrança"} width={170} visible={this.state.acaoSolicitacaoCobranca == 1} />
              <Column dataField={"solicitacaoCorrente.tipoStr"} caption={"Solicitação"} width={120} visible={this.state.acaoSolicitacaoCobranca == 2} />
              <Column dataField={"contribuinte.nomeComDocumentoECodigo"} caption={"Contribuinte"} />

              <Column dataField={"principal"} caption={"Principal"} format={{ type: "fixedPoint", precision: 2 }} />
              <Column
                dataField={"total"}
                caption={"Total"}
                format={{ type: "fixedPoint", precision: 2 }}
              />
              <Summary>
                <TotalItem
                  column="contribuinte.nomeComDocumentoECodigo"
                  summaryType="sum"
                  valueFormat="currency"
                  alignment={"right"}
                  customizeText={(e) => "Total"}
                />
                <TotalItem
                  column="principal"
                  summaryType="sum"
                  valueFormat="currency"
                  customizeText={this.customizarTextoSumary}
                />
                <TotalItem
                  column="total"
                  summaryType="sum"
                  valueFormat="currency"
                  customizeText={this.customizarTextoSumary}
                />
              </Summary>
            </DataGrid>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarSolicitarCobranca,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupSolicitarCobranca: false }),
              }}
            ></ToolbarItem>
          </Popup>

          <Popup
            visible={this.state.popupCarregando}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={false}
            width={"120"}
            height={"120"}
          >
            <div style={{ textAlign: "center" }}>
              <LoadIndicator width={60} height={60} />
              Carregando...
            </div>

          </Popup>

          <Popup
            visible={this.state.popupSucessoSolicitacao}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Resultado Solicitações"
          >
            <DataGrid
              dataSource={this.state.dadosSucessoSolicitacao}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
              filterSyncEnabled={true}
              wordWrapEnabled={true}
              height={"95%"}
            >
              <Paging pageSize={this.state.dadosSucessoSolicitacao.length} />
              <Pager visible={false} />
              <Column dataField={"cdaExercicio"} caption={"Exercício"} width={120} alignment={"center"} />
              <Column dataField={"cdaNumero"} caption={"Número"} width={150} alignment={"center"} />
              <Column dataField={"cdaStatus"} caption={"Status CDA"} width={170} alignment={"center"} />
              <Column dataField={"tipoCobranca"} caption={"Tipo Cobrança"} width={170} alignment={"center"} />
              <Column dataField={"status"} caption={"Número"} width={170} alignment={"center"} />
              <Column dataField={"msg"} caption={"Mensagem"} />

            </DataGrid>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupSucessoSolicitacao: false, popupSolicitarCobranca: false, popupCarregando: false, selecionando: false, cdasSelecionadas: [] }, () => this.filtrar()),
              }}
            ></ToolbarItem>
          </Popup>
        </div >
      </React.Fragment >
    );
  }

  customizarTextoSumary(data) {
    return `${formatNumber(data.value, { type: "fixedPoint", precision: 2 })}`;
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/cda/novo");
  }
}


